module.exports = __webpack_public_path__ + "img/_pin_note.12a4c13b.svg";